import { ReactLenis, useLenis } from "lenis/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollTop = () => {
  const lenis = useLenis();
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, lenis]);
  return null;
};

const SmoothScroll = ({ children }) => {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true, wheelMultiplier: 1 }}>
      <ScrollTop />
      {children}
    </ReactLenis>
  );
};

export default SmoothScroll;
